import React, { useState, useEffect } from 'react';

const InputForm = ({ onFormChange, initialData }) => {
  const [formData, setFormData] = useState(initialData || {
    introduction: 'Introduction',
    greeting: 'Greeting'
  });

  useEffect(() => {
    console.log('initialData changed:', initialData);
    if (initialData) {
      setFormData(initialData);
    }
  }, [initialData]);

  const handleChange = (field, value) => {
    console.log('handleChange:', field, value);
    const newData = { ...formData, [field]: value };
    setFormData(newData);
    onFormChange?.(newData);
  };

  return (
    <>
      <div className="mb-3">
        <label className="block text-sm font-bold mb-1">Name</label>
        <input className="w-full border rounded px-3 py-2 bg-gray-100" placeholder="Optional: The name of the agent" />
      </div>
      <div className="mb-3">
        <label className="block text-sm font-bold mb-1">Introduction</label>
        <textarea 
          className="w-full border rounded px-3 py-2 bg-gray-100" 
          rows={2}
          value={formData.introduction}
          onChange={(e) => handleChange('introduction', e.target.value)}
        />
      </div>
      <div className="mb-3">
        <label className="block text-sm font-bold mb-1">Greeting</label>
        <textarea 
          className="w-full border rounded px-3 py-2 bg-gray-100" 
          rows={2}
          value={formData.greeting}
          onChange={(e) => handleChange('greeting', e.target.value)}
        />
      </div>
    </>
  );
};

export { InputForm };
